import fetch from "./fetch";
/**
 * 获取所有项目
 */
const projects = {
  //登录
  projectsRequst() {
    return fetch({
      isLoading: true,
      url: "/v1/sys/getProject",
      method: "GET",
      params: {},
    });
  },
};

export default projects;
